import React from 'react';
export const Logo = ({
  className = ''
}) => {
  return <div className={`flex items-center ${className}`} data-id="element-194">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/14kF1wCb92L9YmyvwEovLF/ChatGPT_Image_Oct_7%2C_2025%2C_04_41_25_AM.png" alt="Sapis Capital Group Logo" className="h-10 md:h-12" style={{
      backgroundColor: 'transparent'
    }} data-id="element-195" />
    </div>;
};